module.exports = __webpack_public_path__ + "img/9788988613634.8aa2a589.jpg";